import React, { Component } from 'react';
import SheduleEntryModal from './modals/SheduleEntryModal';
import moment from 'moment';
import { Button } from '@blueprintjs/core';

const dayHeight = 600;

function getMinuteOfDay(hour, minute) {
  return (hour * 60 + minute);
}

function getYPositionForTime(hour, minute) {
  const minuteOfDay = getMinuteOfDay(hour, minute);
  const yPos = minuteOfDay / 1440 * dayHeight;
  return yPos;
}

function entryIsOnDay(entryStart, entryEnd, dayStart, dayEnd) {
  return (
    dayStart.isBetween(entryStart, entryEnd)
    || dayEnd.isBetween(entryStart, entryEnd)
    || entryStart.isBetween(dayStart, dayEnd)
    || moment(dayStart).add(1, 'week').isBetween(entryStart, entryEnd)
    || moment(dayEnd).add(1, 'week').isBetween(entryStart, entryEnd)
  );
}

class Shedule extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showSheduleEntryModalForID: false,
    }
  }

  renderEntriesForDay(day) {
    const entries = [];
    const beginOfDay = moment().day(day).startOf('day');
    const endOfDay = moment().day(day).endOf('day');

    for (let key in this.props.shedule) {
      if (!this.props.shedule.hasOwnProperty(key)) continue;

      const entry = this.props.shedule[key];
      const start = moment().day(entry.startDay).hour(entry.startHour).minute(entry.startMinute);
      let end = moment().day(entry.endDay).hour(entry.endHour).minute(entry.endMinute);
      if (end.isBefore(start)) {
        end.add(1, 'weeks');
      }

      if (end.day() === day && end.hour() === 0 && end.minute() === 0) continue;
      if (!entryIsOnDay(start, end, beginOfDay, endOfDay)) continue;

      const startPos = start.day() !== day ? 0 : getYPositionForTime(start.hour(), start.minute());
      const endPos = end.day() !== day ? dayHeight : getYPositionForTime(end.hour(), end.minute());
      const height = endPos - startPos;
      const playlist = this.props.playlists[entry.playlist]
      const backgroundColor = playlist ? playlist.color || 'darkgrey' : 'darkgrey';
      entries.push(
        <div
          key={key}
          style={{ position: 'absolute', top: startPos, height, width: '100%', backgroundColor }}
          onClick={ () => this.setState({ showSheduleEntryModalForID: key }) }
        >
          <b>{height >= 20 ? (playlist ? playlist.name : 'Playlist nicht gefunden') : ''}</b>
        </div>
      );
    }
    return entries;
  }

  render() {
    return (
      <div class="pt-card">
        <h3>Zeitplan</h3>
        <Button
          text="Neuer Eintrag"
          iconName="calendar"
          onClick={() => this.setState({ showSheduleEntryModalForID: 'new' })} />
        <div style={{ display: 'flex', width: '100%', backgroundColor: 'rgb(240,240,240)', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>
          <div style={{ flex: 1, borderLeftWidth: 1, borderColor: 'black' }}></div>
          <div style={{ flex: 1, borderLeftWidth: 1, borderColor: 'black', textAlign: 'center' }}>Montag</div>
          <div style={{ flex: 1, borderLeftWidth: 1, borderColor: 'black', textAlign: 'center' }}>Dienstag</div>
          <div style={{ flex: 1, borderLeftWidth: 1, borderColor: 'black', textAlign: 'center' }}>Mittwoch</div>
          <div style={{ flex: 1, borderLeftWidth: 1, borderColor: 'black', textAlign: 'center' }}>Donnerstag</div>
          <div style={{ flex: 1, borderLeftWidth: 1, borderColor: 'black', textAlign: 'center' }}>Freitag</div>
          <div style={{ flex: 1, borderLeftWidth: 1, borderColor: 'black', textAlign: 'center' }}>Samstag</div>
          <div style={{ flex: 1, borderLeftWidth: 1, borderColor: 'black', textAlign: 'center' }}>Sonntag</div>
        </div>
        <div style={{ display: 'flex', width: '100%', backgroundColor: 'rgb(240,240,240)', position: 'relative' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>00:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>01:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>02:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>03:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>04:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>05:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>06:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>07:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>08:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>09:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>10:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>11:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>12:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>13:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>14:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>15:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>16:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>17:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>18:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>19:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>20:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>21:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>22:00</div>
            <div style={{ flex: 1, width: '100%', borderWidth: 0, borderStyle: 'solid', borderBottomWidth: 1, borderColor: 'black' }}>23:00</div>
          </div>
          <div style={{ flex: 1, height: dayHeight, flexGrow: 1, position: 'relative' }} />
          <div style={{ flex: 1, height: dayHeight, flexGrow: 1, position: 'relative', borderWidth: 0, borderStyle: 'solid', borderLeftWidth: 1, borderColor: 'black' }}>
            {this.renderEntriesForDay(1)}
          </div>
          <div style={{ flex: 1, height: dayHeight, flexGrow: 1, position: 'relative', borderWidth: 0, borderStyle: 'solid', borderLeftWidth: 1, borderColor: 'black' }}>
            {this.renderEntriesForDay(2)}
          </div>
          <div style={{ flex: 1, height: dayHeight, flexGrow: 1, position: 'relative', borderWidth: 0, borderStyle: 'solid', borderLeftWidth: 1, borderColor: 'black' }}>
            {this.renderEntriesForDay(3)}
          </div>
          <div style={{ flex: 1, height: dayHeight, flexGrow: 1, position: 'relative', borderWidth: 0, borderStyle: 'solid', borderLeftWidth: 1, borderColor: 'black' }}>
            {this.renderEntriesForDay(4)}
          </div>
          <div style={{ flex: 1, height: dayHeight, flexGrow: 1, position: 'relative', borderWidth: 0, borderStyle: 'solid', borderLeftWidth: 1, borderColor: 'black' }}>
            {this.renderEntriesForDay(5)}
          </div>
          <div style={{ flex: 1, height: dayHeight, flexGrow: 1, position: 'relative', borderWidth: 0, borderStyle: 'solid', borderLeftWidth: 1, borderColor: 'black' }}>
            {this.renderEntriesForDay(6)}
          </div>
          <div style={{ flex: 1, height: dayHeight, flexGrow: 1, position: 'relative', borderWidth: 0, borderStyle: 'solid', borderLeftWidth: 1, borderColor: 'black' }}>
            {this.renderEntriesForDay(0)}
          </div>
        </div>
        <SheduleEntryModal
          entryID={this.state.showSheduleEntryModalForID}
          entry={this.state.showSheduleEntryModalForID && this.props.shedule[this.state.showSheduleEntryModalForID]}
          entries={this.props.shedule}
          availablePlaylists={this.props.playlists}
          database={this.props.database}
          customerID={this.props.customerID}
          show={Boolean(this.state.showSheduleEntryModalForID)}
          hide={() => this.setState({ showSheduleEntryModalForID: false })}
        />
      </div>
    );
  }
}

export default Shedule;



/** WEBPACK FOOTER **
 ** ./src/Shedule.js
 **/